import Vue from 'vue'
import VeeValidate from 'vee-validate';
import { Validator } from 'vee-validate';

Vue.use(VeeValidate);

// Register custom validator attributes.
Validator.extend('personalNumber', {
  validate: value => /^((19|20)(\d{2})(0[1-9]|1[012])(0[1-9]|1[0-9]|2[0-9]|3[01])(-)?(\d{4}))$/.test(value)
});

Validator.extend('organisationNumber', {
  validate: value => /^((\d{2})([2-9])(\d{3})(-)?(\d{4}))$/.test(value)
});